/**
 * @file bootstrap.ts
 * Initializes shared packages in a scope of the Module Federation.
 * Then loads index.tsx. Shared packages will be there already.
 */
import('vendor')
import('shared')
import('sharedUI')
import('knowledgeBase/index')
